import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { ServiceType } from '../servicetype.model';
import { ServicetypeService } from '../servicetype.service';

@Component({
  selector: 'app-servicetypeform',
  templateUrl: './servicetypeform.component.html',
  styleUrls: ['./servicetypeform.component.css']
})
export class ServicetypeformComponent implements OnInit {

  //#region variables

  serviceType: ServiceType = {} as ServiceType;
  updateMode = false;
  imagPath: any;
  active = true;
  spinnerOverlay = false;
  language!: number;

  constructor(private router: Router,
    private service: ServicetypeService,
    private globle: Globle,
    private snackBar: MatSnackBar,
    private activateRoute: ActivatedRoute,
    private localStorage: LocalStorageService,
    private translate: TranslateService) { }

  ngOnInit(): void {
    this.imagPath = this.globle.imgPath;
    this.language = this.localStorage.retrieve("lang");
    this.getUrlParam();
  }


  getUrlParam() {
    this.activateRoute.paramMap.subscribe(param => {
      if (param.get("id") != null) {
        this.updateMode = true;
        this.getById();
      }
    })
  }

  getById() {
    this.service.getById(this.serviceType.id).subscribe(data => {
      this.serviceType = data
      this.serviceType.status == 1 ? this.active = true : this.active = false;
    })
  }

  back() {
    this.router.navigate(["./master/efawateercome/efbillersservicetypelist"]);
  }

  submit() {

    this.spinnerOverlay = true;
    this.active ? this.serviceType.status = 1 : this.serviceType.status = 0;
    this.update()
  }

  update() {
    this.spinnerOverlay = true;
    this.service.Update(this.serviceType).subscribe(data => {
      this.spinnerOverlay = false;
      this.openSnackBar(this.translate.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.back();
    },
      error => {
        console.log(error);
        if (error.error.message != undefined) {
          this.openSnackBar(error.error.message, 'snackBarError');
        }
        else {
          this.openSnackBar("Internal server error", 'snackBarError');
        }
        this.spinnerOverlay = false;
      })
  }

  openSnackBar(message: any, cssclass: any) {
    this.snackBar.open(message, 'X', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

}
